import { getField } from "vuex-map-fields";

const coverageCodesOptions = (state) => Object
  .entries(state.initialCreateOrEditPageData?.coverageCodes || [])
  // eslint-disable-next-line
  .sort(([_A, valueA], [_B, valueB]) => {
    return valueA < valueB ? -1 : 1;
  })
  .map(([key, value]) => ({ label: value, value: Number(key) }));

const packageId = (state) => state.form?.parent_id;
const branches = (state) => state.initialCreateOrEditPageData?.branches || [];

const form = (state) => state.form;

const viewOptions = (state) => state.viewOptions[state.form?.view_group_id];
const agency = (state) => state.package?.agency?.id;
const agencies = (state) => state.initialCreateOrEditPageData?.agencies || [];
const packages = (state) => state.initialCreateOrEditPageData?.packages || [];
const productLabels = (state) => state.initialCreateOrEditPageData?.productLabels || [];

const productLabelsOptions = (state) => Object
  .entries(state.initialCreateOrEditPageData?.productLabels || [])
  .map(([key, value]) => ({ label: value, value: Number(key) }));
const mutationCodes = (state) => state.initialCreateOrEditPageData.mutationCodes;

const mutationCodeOptions = (state) => Object
  .entries(state.initialCreateOrEditPageData.mutationCodes)
  .map(([key, value]) => ({ label: value, value: Number(key) }));
const insuranceBranches = (state) => state.initialCreateOrEditPageData.insuranceBranches;
const coverageCodes = (state) => state.initialCreateOrEditPageData.coverageCodes;
const isSinglePolicy = (state) => !state.form?.parent_id;

const isEditing = (state) => !!state.policyId || !!state.form?.id;
const hasPolicy = (state) => !!state.policyId;
const viewGroups = (state, getters) => state.viewGroups[getters.activeBranchId];

const activeBranchId = (state) => state.form?.branch_id;
const views = (state) => {
  if (state.form.view_group_id in state.viewOptions) {
    return state.viewOptions[state.form.view_group_id].views;
  }
  return [];
};
const requiredViews = (state) => {
  if (state.form.view_group_id in state.viewOptions) {
    return state.viewOptions[state.form.view_group_id].required_views;
  }
  return [];
};
const optionalViews = (state) => {
  if (state.form.view_group_id in state.viewOptions) {
    return state.viewOptions[state.form.view_group_id].views;
  }
  return [];
};
const requiredViewsOptions = (state, getters) => getters.requiredViews
  .map((view) => ({ label: view.name, value: view.id.toString() }));

const requiredViewsValues = (state, getters) => getters.requiredViews
  .map((view) => (view.id.toString()));

const fieldsGroupedByView = (state) => state.views[state.form.view_group_id];
const isPackage = (state) => state?.form?.is_package;
const loadingPage = (state) => state.loadingPage;

const loadingViews = (state) => state.loadingViews;
const viewGroupsAlphabetically = (state, getters) => {
  if (!getters.viewGroups) {
    return [];
  }

  // eslint-disable-next-line no-unused-vars
  return Object.entries(getters.viewGroups).sort(([idA, nameA], [idB, nameB]) => {
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
};

const premiumMatrices = (state) => state.initialCreateOrEditPageData?.premiumMatrices || [];
const hasBonusMalus = (state) => {
  if (!(state.form?.view_group_id in state.viewOptions)) return false;
  return !!state.viewOptions[state.form?.view_group_id]?.bm;
};

const packageName = (state) => state.package?.name;

const showNoteDyn1 = (state) => state.show_note_dyn1;

export default {
  premiumMatrices,
  hasBonusMalus,
  viewGroups,
  fieldsGroupedByView,
  loadingPage,
  requiredViews,
  requiredViewsOptions,
  requiredViewsValues,
  views,
  hasPolicy,
  coverageCodes,
  insuranceBranches,
  form,
  productLabels,
  productLabelsOptions,
  isEditing,
  loadingViews,
  mutationCodes,
  agency,
  agencies,
  activeBranchId,
  packages,
  packageName,
  branches,
  coverageCodesOptions,
  viewOptions,
  mutationCodeOptions,
  isSinglePolicy,
  packageId,
  isPackage,
  getField,
  viewGroupsAlphabetically,
  optionalViews,
  showNoteDyn1,
};
